import type { ComponentType } from 'react';
import { useCalendarLocalizer, useCalendarWeekStartsOn } from '@s20/hooks/tenant.hooks';

/** What `withCalendarWeekStart` adds to the wrapped calendar's own props. */
export interface CalendarWeekStartProps {
    /** The language's first day of the week, 0 = Sunday ... 6 = Saturday. */
    calendarWeekStartsOn: number;
    /** A react-big-calendar localizer whose grid starts on that day. */
    localizer: ReturnType<typeof useCalendarLocalizer>;
}

/**
 * Gives a class-component calendar the language's first day of the week (`calendarWeekStartsOn`, 0 = Sunday)
 * and a react-big-calendar `localizer` whose grid starts on that day, memoised on the language.
 */
export const withCalendarWeekStart = <P extends object>(Component: ComponentType<P & CalendarWeekStartProps>) =>
    function WithCalendarWeekStart(props: P) {
        const calendarWeekStartsOn = useCalendarWeekStartsOn();
        const localizer = useCalendarLocalizer();

        return (
            <Component
                {...props}
                calendarWeekStartsOn={calendarWeekStartsOn}
                localizer={localizer}
            />
        );
    };
